import React from "react";
import {Box, CircularProgress} from '@mui/material';

export function LoadingSpinner(){
    return(
        <Box sx={{display : "flex", alignItems : "center" , justifyContent : "center"}}>
            <CircularProgress color="primary" variant="indeterminate"  size={200} thickness={25} sx={{alignSelf : "center" }} />
        </Box>     
    )
}